import React from "react";

const LOGO_COLOR = "/logos/razmek-color.svg";
const LOGO_WHITE = "/logos/razmek-white.svg";

/**
 * Razmek logo (SVG).
 * variant: "light" (for white bg — full color) | "dark" (for dark bg — white monochrome)
 */
export const Logo = ({ variant = "light", compact = false, className = "" }) => {
  const src = variant === "dark" ? LOGO_WHITE : LOGO_COLOR;
  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={src}
        alt="RAZMEK Seguros e Inversiones"
        style={{ height: compact ? 36 : 52, width: "auto" }}
        loading="eager"
        className="block"
      />
    </div>
  );
};

export default Logo;
